import { type IntlShape } from 'react-intl';

export const TONE_PRESETS = (formatMessage: IntlShape['formatMessage']) => [
  {
    id: 'EMPATHETIC_COACH',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.edit_modal.fields.tone_preset.options.empathic_coach',
      defaultMessage: 'Empathetic coach',
    }),
    formality: 3,
    directness: 3,
    proactivity: 7,
    challenge_level: 3,
    empathy_balance: 9,
  },
  {
    id: 'DIRECT_ADVISOR',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.edit_modal.fields.tone_preset.options.direct_advisor',
      defaultMessage: 'Direct advisor',
    }),
    formality: 6,
    directness: 9,
    proactivity: 6,
    challenge_level: 6,
    empathy_balance: 3,
  },
  {
    id: 'STRATEGIC_THOUGHT_PARTNER',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.edit_modal.fields.tone_preset.options.strategic_thought_partner',
      defaultMessage: 'Strategic thought partner',
    }),
    formality: 5,
    directness: 5,
    proactivity: 8,
    challenge_level: 8,
    empathy_balance: 5,
  },
  {
    id: 'COMPLIANCE_GUARDIAN',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.edit_modal.fields.tone_preset.options.compliance_guardian',
      defaultMessage: 'Compliance guardian',
    }),
    formality: 9,
    directness: 8,
    proactivity: 4,
    challenge_level: 3,
    empathy_balance: 2,
  },
  {
    id: 'CUSTOM_MIX',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.edit_modal.fields.tone_preset.options.custom_mix',
      defaultMessage: 'Custom mix',
    }),
    formality: 5,
    directness: 5,
    proactivity: 5,
    challenge_level: 5,
    empathy_balance: 5,
  },
];

export const AGENT_TEMPLATES = (formatMessage: IntlShape['formatMessage']) => [
  {
    id: 'PERSONAL_COACH',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.personal_coach.name',
      defaultMessage: 'Personal Coach',
    }),
    description: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.personal_coach.description',
      defaultMessage:
        'Help individuals reflect on their work, growth, and feedback, and recommend learning paths, mentors, and skill development resources.',
    }),
  },
  {
    id: 'MANAGER_COACH',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.manager_coach.name',
      defaultMessage: 'Manager Coach',
    }),
    description: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.manager_coach.description',
      defaultMessage:
        'Coach managers across the full lifecycle: SBI feedback drafts, coaching prompts, and 1:1 prep; onboarding new managers with 30/60/90 day plans and rituals; and guiding performance cycles with bias checks and calibration.',
    }),
  },
  {
    id: 'HRBP_ADVISOR',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.hrbp_advisor.name',
      defaultMessage: 'HRBP Advisor',
    }),
    description: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.hrbp_advisor.description',
      defaultMessage:
        'Answer policy questions with citations and escalation paths.',
    }),
  },
  {
    id: 'PEOPLE_ANALYTICS',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.people_analytics.name',
      defaultMessage: 'People Analytics',
    }),
    description: formatMessage({
      id: 'app.views.ai.agents.agents_admin.templates.people_analytics.description',
      defaultMessage: 'Provide safe, read-only insights on people metrics.',
    }),
  },
];

export const AGENT_STATUSES = (formatMessage: IntlShape['formatMessage']) => [
  {
    id: 'D',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.table.status.draft',
      defaultMessage: 'Draft',
    }),
  },
  {
    id: 'A',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.table.status.initializing',
      defaultMessage: 'Initializing',
    }),
  },
  {
    id: 'P',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.table.status.published',
      defaultMessage: 'Published',
    }),
  },
  {
    id: 'M',
    name: formatMessage({
      id: 'app.views.ai.agents.agents_admin.table.status.pending_changes',
      defaultMessage: 'Pending Changes',
    }),
  },
];
